import { mapGetters } from 'vuex'
import Plans from '@components/Payment/Plans.vue'
// import PlansComparison from '@components/Payment/PlansComparison.vue'

export default {
  name: 'PlansPreview',
  components: {
    'payment-plans': Plans,
    // 'plans-comparison': PlansComparison,
  },
  props: {
    defaultCurrency: {
      type: String,
      default: 'eur',
      required: false,
    },
    showBillingPeriod: {
      type: Boolean,
      default: true,
      required: false,
    },
    defaultBillingPeriod: {
      type: String,
      default: 'monthly',
      required: false,
    },
  },
  data() {
    return {
      currency: this.defaultCurrency,
      billingPeriod: this.defaultBillingPeriod,
    }
  },
  computed: {
    ...mapGetters('plans', ['getPlanItemsByCurrencyAndBillingPeriod']),
    availablePlansPerCurrency() {
      return this.getPlanItemsByCurrencyAndBillingPeriod(this.currency,
        this.billingPeriod)
    },
  },
}
